import type { ObjectDiscussionMessageType } from '@econtractor/types';
import type { DiscussionSort } from './discussionSort';

export const DISCUSSION_HISTORY_LIMIT = 100;

export const latestDiscussionMessageId = (
    messages: readonly ObjectDiscussionMessageType[],
): number => messages.reduce((max, row) => (row.ID > max ? row.ID : max), 0);

export const mergeLatestDiscussionMessages = (
    current: readonly ObjectDiscussionMessageType[],
    incoming: readonly ObjectDiscussionMessageType[],
): ObjectDiscussionMessageType[] => {
    const byId = new Map<number, ObjectDiscussionMessageType>();
    for (const row of current) {
        if (row?.ID) byId.set(row.ID, row);
    }
    for (const row of incoming) {
        if (row?.ID) byId.set(row.ID, row);
    }
    return Array.from(byId.values())
        .sort((a, b) => b.ID - a.ID)
        .slice(0, DISCUSSION_HISTORY_LIMIT);
};

/** oldest — від старішого до новішого. newest — зворотний порядок того ж вікна. */
export const orderDiscussionMessages = (
    messages: readonly ObjectDiscussionMessageType[],
    sort: DiscussionSort,
): ObjectDiscussionMessageType[] => {
    const chronological = [...messages].sort((a, b) => a.ID - b.ID);
    return sort === 'oldest' ? chronological : [...chronological].reverse();
};
